/*
 * @Date: 2021-04-19 10:15:06
 * @Author: zhujuan
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-01-19 10:32:14
 */
import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/src/utils/resize-event'

// 设置表格高度

const doResize = async (el, binding, vnode) => {
  const { value } = binding
  // 获取距底部距离(用于展示页码等信息)
  const bottomOffset = (value && value.bottomOffset) || 58
  const closeAutoHeight = (value && value.closeAutoHeight) || false
  if (closeAutoHeight) return
  // 计算高度并设置
  const height =
    window.innerHeight - el.getBoundingClientRect().top - bottomOffset
  el.style.height = height + 'px'
}

export default {
  // 初始化设置

  bind(el, binding, vnode) {
    // 设置resize监听方法

    el.resizeListener = async () => {
      await doResize(el, binding, vnode)
    }

    // 绑定监听方法到addResizeListener

    addResizeListener(window.document.body, el.resizeListener)
  },

  // 绑定默认高度

  async inserted(el, binding, vnode) {
    await doResize(el, binding, vnode)
  },

  // 销毁时设置

  unbind(el) {
    // 移除resize监听

    removeResizeListener(el, el.resizeListener)
  }
}
